import SvgIcon from '../SvgIcon/SvgIcon';

function ArrowDownIcon({ ...props }) {
  return (
    <SvgIcon {...props}>
      <path d="M16.66,8.45a1.2,1.2,0,1,1,1.69,1.7L12.46,16,6.65,10.14A1.2,1.2,0,1,1,8.36,8.45l4.11,4.15Z" />
    </SvgIcon>
  );
}

export default ArrowDownIcon;
